<template>
  <div class="page">
    <div autoplay="autoplay" class="page-container" :style="statusPading">
      <div class="statusBg B1"></div>
      <Player
        v-if="!isShowCover"
        class="video B1"
        :style="statusPading"
        @onStartPlay="onStartPlay"
      >
        <div class="try-see-wrap" v-if="isShowTrySee && isSuppotUnlock">
          <div class="font-wrap">
            <div class="icon"></div>
            {{ trySeeTime }}试看， 您可以使用会员特权解锁
          </div>

          <div class="unlock" @click="unlock">去解锁</div>
        </div></Player
      >
      <VideoMask
        v-if="isMaskShowFix"
        :style="[statusPading, videoHeightStyle]"
      />
      <div :style="videoHeightStyle" />
      <div
        class="cover B1"
        v-if="isShowCover"
        :style="[statusPading, videoHeightStyle]"
        style="z-index: 10002"
      >
        <img
          class="imgDefault"
          :src="
            resp && resp.detail && resp.detail.detail.coverImagUrl
              ? resp.detail.detail.coverImagUrl
              : ''
          "
          style="width: 100%;'object-fit': 'cover'"
          :style="[videoHeightStyle]"
          alt=""
        />
        <img
          src="../../static/ic_play_grey.png"
          class="btnPlay"
          @click="playCourseVideo(resp.detail.courses.page.list[0])"
          alt=""
        />
      </div>
      <template v-if="getTodayTip">
        <div class="S8 T1 marginL30 jrgxTitle">今日更新</div>
        <div
          class="videoToday"
          @click="playCourseVideo(getTodayTip)"
          :class="getTodayTip.videoIdenftity === currentVideo ? 'C5' : 'T1'"
        >
          【{{ dayjs(getTodayTip.updateTime).format('MM-DD') || '' }}】
          {{ getTodayTip.title || '' }}
          <img src="../../static/ic_play_grey.png" />
        </div>
      </template>
      <van-sticky :offset-top="navOffest">
        <NavItem
          :items="navItems"
          @onItemClick="onItemClick"
          class="sepBottom B1"
        />
      </van-sticky>
      <swiper
        :options="swiperOption"
        class="my-swiper"
        ref="mySwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <CourseVideoDetail
            @updateSwiper="updateSwiper"
            @playCourseVideo="playCourseVideo"
          />
        </swiper-slide>
        <swiper-slide>
          <Comment
            @updateSwiper="updateSwiper"
            videoType="shrink"
            :showPupInput="!showCommentDetail && !!currentIndex"
            :hasPermission="hasPermission(productId)"
            @onReplyEvent="onReplyEvent"
            @onShowAllEvent="onShowAllEvent"
            :commentsInfo="commentsInfo"
          />
        </swiper-slide>
      </swiper>
      <PayBanner
        :subscribeStatus="
          resp &&
            resp.detail &&
            resp.detail.detail &&
            resp.detail.detail.subscribeStatus
        "
        videoType="shrink"
        v-show="!(hasPermission(productId) && !!currentIndex)"
      />
    </div>

    <div
      class="comment-container B1"
      :style="[commentStyle, statusPading]"
      v-if="showCommentDetail"
      @touchmove.stop
    >
      <CommentDetail
        :commentsInfo="commentsInfo"
        :comment="currComment"
        :isPermission="hasPermission(productId)"
        :isShowAll="isShowAll"
        @onCloseEvent="onCloseEvent"
      />
    </div>

    <div
      class="onlineservice"
      :style="[onlineserviceStyle]"
      v-if="isSupportIM"
      @click="goIM()"
    >
      <img
        style="width: 100%;"
        src="../../static/ic_online_service.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import http from '../../api/http'
import NavItem from '../comm/NavItem'
import CourseVideoDetail from './CourseVideoDetail'
import PayBanner from '../video/PayBanner'
import CommentDetail from '@/views/comment/CommentDetail'
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
import Player from '@/views/video/Player'
import util from '@/util/util'
import comm from '@/comm'
import {
  requestappInfo,
  getStatusHeight,
  getAppInfo,
  isAndroid,
  state
} from '@/api/appInfo'
import { checkPermission, hasPermission } from '@/api/permission'
import Comment from '@/views/comment/Comment'
import VideoMask from '@/views/video/VideoMask'
import { Dialog, Sticky } from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isGuest } from '../../api/appInfo'
import Urls from '../../assets/js/Urls'
import { openurl } from '@em/ym'
import api from '../../api/api'
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)

export default {
  name: 'Video',
  components: {
    VideoMask,
    Player,
    PayBanner,
    Comment,
    CourseVideoDetail,
    NavItem,
    CommentDetail,
    [Sticky.name]: Sticky,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      productId: '',
      isShowCover: true,
      currComment: {},
      currentIndex: 0,
      isShowAll: false,
      isMaskShow: false,
      navItems: [
        {
          name: '详情',
          isSelect: true
        },
        {
          name: '评论',
          isSelect: false
        }
      ],
      swiperOption: {
        autoplay: false,
        autoHeight: true,
        observer: true,
        observeParents: true
      },
      isGoldMember: false,
      isShowTrySee: false,
      trySeeTime: 0,
      goodsInfo: '',
      couponList: [],
      couponNo: 0,
      currentItem: ''
    }
  },

  computed: {
    ...mapState('video', ['resp', 'currentVideo']),
    navOffest() {
      return isNaN(getStatusHeight())
        ? util.getVideoHeight()
        : util.getVideoHeight() + getStatusHeight()
    },

    commentsInfo() {
      return this.resp.detail ? this.resp.detail.commentsInfo : null
    },

    statusPading() {
      return {
        marginTop: getStatusHeight() + 'px'
      }
    },

    showCommentDetail() {
      return Object.keys(this.currComment).length > 0
    },

    getTodayTip() {
      return this.resp.detail ? this.resp.detail.toDayCourse : null
    },

    videoHeightStyle() {
      console.log(util.getVideoHeight(), 'videoheight---')
      return {
        height: util.getVideoHeight() + 'px'
      }
    },

    commentStyle() {
      const top = util.getVideoHeight() + 'px'
      const statusHeight = getStatusHeight()
      const commentHeight =
        window.screen.height - util.getVideoHeight() - statusHeight + 'px'
      return {
        top: top,
        height: commentHeight
      }
    },
    isMaskShowFix() {
      return this.isMaskShow && !isAndroid()
    },

    isSupportIM() {
      if (!state.appInfoResp.appVersion) return false
      return (
        util.compareMv('3.2.0', state.appInfoResp.appVersion, true) &&
        this.resp?.detail?.isShowIM
      )
    },

    onlineserviceStyle() {
      return {
        top:
          (isNaN(getStatusHeight()) ? 0 : getStatusHeight()) +
          25 +
          util.getVideoHeight() +
          'px'
      }
    },
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    isSuppotUnlock() {
      return util.compareMv('3.8.0', state.appInfoResp.appVersion, true)
    }
  },

  watch: {
    showCommentDetail(val) {
      this.bodyElm = this.bodyElm || document.body
      val
        ? (this.bodyElm.style.overflow = 'hidden')
        : (this.bodyElm.style.overflow = 'auto')
    },
    resp(val) {
      this.productId = val.detail.detail.productId
      this.$set(
        this.navItems[1],
        'title',
        val.detail.commentsInfo.commentsCount
      )
      checkPermission(this.productId, () => {
        this.playCourseVideo(val.detail.courses.page.list[0])
        let hasPermission = this.hasPermission(this.productId)
        if (hasPermission) {
          this.currentIndex = 0
          this.navItems[1].isSelect = false
          this.navItems[0].isSelect = true
        }
      })
      this.tryShowShare()
    }
  },
  created() {
    this.getUserInfo()
    this.getMemberPermission()
    this.getCouponData()
  },
  mounted() {
    const param = {
      setId: comm.getQueryString('setId')
    }
    this.requestDetail(param)
    requestappInfo()
    window.onResume = () => {
      requestappInfo()
      let hasPermission = this.hasPermission(this.productId)
      let _this = this
      if (!hasPermission) {
        setTimeout(
          () =>
            checkPermission(this.productId, function() {
              _this.requestDetail(param)
            }),
          5000
        )
      }
    }

    window.onscroll = this.updateMaskPosition
    let lastOrientationChangeTime
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      () => {
        setTimeout(() => {
          this.updateMaskPosition()
        }, 500)
        lastOrientationChangeTime = new Date().getTime()
      },
      false
    )
    const innerH = window.innerHeight
    window.addEventListener('resize', () => {
      setTimeout(() => {
        if (new Date().getTime() - lastOrientationChangeTime < 300) return
        if (window.orientation === 180 || window.orientation === 0) {
          window.scrollBy(0, window.innerHeight < innerH ? 300 : -300)
        }
      }, 100)
    })
  },
  methods: {
    ...mapActions('video', ['requestDetail', 'requestVideo']),
    ...mapActions('appInfo', ['requestappInfo']),
    hasPermission,

    dayjs,
    onItemClick(index) {
      this.currentIndex = index
      this.swiper.slideTo(index)
    },
    updateSwiper() {
      this.swiper.update()
    },
    slideChange() {
      this.currentIndex = this.swiper.activeIndex
      this.navItems[this.currentIndex].isSelect = true
      this.navItems[this.currentIndex ^ 1].isSelect = false
    },

    onReplyEvent(item) {
      console.log('=======onReplyEvent', item)
      this.currComment = item
    },
    onShowAllEvent(val) {
      this.isShowAll = val
    },
    onCloseEvent() {
      this.currComment = ''
    },

    playCourseVideo(course) {
      if (getAppInfo().networkState !== 1) {
        this.$toast('正在消耗流量')
      }
      if (course.isHightlight) {
        this.$toast('正在播放课程花絮，购买后观看完整课程。')
        this.isShowTrySee = true
        this.trySeeTime = this.formatDuration(course.hightlightDuration)
      } else {
        this.isShowTrySee = false
      }

      if (window.goods) {
        window.goods.showVideoMask(!course.isHightlight)
      }

      this.isShowCover = false
      this.requestVideo({
        videoIdentity: course.isAvailable
          ? course.videoIdentity
          : course.hightlightVideoIdentity
      })
      this.currentItem = course
      console.error('this.currentItem', this.currentItem)
    },

    onStartPlay() {
      this.isMaskShow = true
      this.updateMaskPosition()
    },

    updateMaskPosition() {
      let mask = document.querySelector('video')
      let rect = mask.getBoundingClientRect()
      if (window.goods) {
        if (window.orientation === 180 || window.orientation === 0) {
          let devicePixelRatio = window.devicePixelRatio

          window.goods.updateVideoMask(
            this.isMaskShow,
            rect.x * devicePixelRatio,
            rect.y * devicePixelRatio,
            rect.width * devicePixelRatio,
            rect.height * devicePixelRatio
          )
        } else if (window.orientation === 90 || window.orientation === -90) {
          //横屏交给native全屏
          window.goods.updateVideoMask(this.isMaskShow, 0, 0, 0, 0)
        }
      }
    },

    tryShowShare() {
      if (getAppInfo().appVersion >= '3.1.0') {
        http
          .post('Course/api/GetShare', { setId: this.resp.detail.detail.setId })
          .then(response => {
            window.goods.showShare(
              JSON.stringify({
                isShow: true,
                title: response.detail.title,
                content: response.detail.content,
                url: response.detail.url
              })
            )
          })
      }
    },

    goIM() {
      util.go('ycstock://onlineservice?code=course')
    },
    formatDuration(duration) {
      const formatted = dayjs(duration * 1000).utc()
      const h = formatted.hour()
      const m = formatted.minute()
      const s = formatted.second()

      let result = ''
      if (h > 0) result += `${h}小时`
      if (m > 0) result += `${m}分钟`
      if (s > 0) result += `${s}秒`

      return result || '0秒' // 如果 duration = 0，返回 '0秒'
    },
    unlock() {
      if (isGuest()) {
        // util.go('ycstock://login')
        // return
      }
      // 非会员提示开通
      if (!this.isGoldMember) {
        Dialog.confirm({
          title: '提示',
          confirmButtonText: '去开通',
          message: `您尚未开通会员\n开通后将享有解锁特权`,
          confirmButtonColor: '#046bcc',
          cancelButtonColor: '#999'
        }).then(() => {
          // 前往收银台
          const url = `${Urls.DOMAIN_YOUKANTOUWAP}/ykt-cashier/?setId=${this.goodsInfo.goodsSetId}`
          openurl(url)
        })
        return
      } else {
        // 会员提示解锁
        if (this.couponNo > 0) {
          // 有解锁券
          Dialog.confirm({
            title: '提示',
            confirmButtonText: '确定解锁',
            message: `您有${this.couponNo}张课程解锁券，\n确定使用1张解锁该节课程吗？`,
            confirmButtonColor: '#046bcc',
            cancelButtonColor: '#999'
          }).then(() => {
            // 解锁
            this.creteUnlockOrder()
          })
        } else {
          // 无解锁券
          Dialog.alert({
            title: '提示',
            confirmButtonText: '知道了',
            message: `您的会员解锁特权已用完\n无法解锁该节课程`,
            confirmButtonColor: '#046bcc',
            cancelButtonColor: '#999'
          }).then(() => {
            // 前往收银台
          })
        }
      }
    },
    async getUserInfo() {
      const { detail, result } = await api.member.getUserInfo()
      if (result.code === 0) {
        if (detail.memberInfo && detail.memberInfo.level === 2) {
          this.isGoldMember = true
        }
      }
    },
    async getMemberPermission() {
      const { detail, result } = await api.member.getMemberPermission()
      if (result.code === 0) {
        console.info('detail.goodsInfo', detail.goodsInfo)
        this.goodsInfo = detail.goodsInfo
      }
    },
    async getCouponData() {
      const { detail, result } = await api.coupon.getCouponApi({
        kind: 1, // 解锁劵
        direction: 2,
        productType: 2, //  2课程
        statusList: [0] // 未使用
      })
      if (result.code === 0) {
        console.info('detail', detail)
        this.couponNo = detail.list.length

        this.couponList = detail.list.map(ite => {
          const currentDate = dayjs()
          ite.btnActive = dayjs(currentDate).isBetween(
            ite.validFrom,
            ite.validEnd
          )
          return ite
        })
      }
    },
    async creteUnlockOrder() {
      const couponNo = this.couponList[0].couponNo
      const { detail, result } = await api.course.creteCouponOrder({
        productId: this.resp.detail.detail.productId,
        subProductId: this.currentItem.courseId,
        couponNo: couponNo
      })
      if (result.code === 0) {
        console.info('detail', detail)
        const orderId = detail
        this.getExchangeResult(orderId)
        setTimeout(() => {
          if (!this.currentItem.isAvailable) {
            this.getExchangeResult(orderId)
          }
        }, 1000)
      }
    },
    async getExchangeResult(orderId) {
      console.info('orderId', orderId)
      const { detail, result } = await api.course.getExchangeResult({
        orderId: orderId
      })
      if (result.code === 0 && detail.success) {
        console.info('detail', detail)
        this.$set(this.currentItem, 'isAvailable', true)
        this.$set(this.currentItem, 'isHightlight', false)
        this.isShowTrySee = false
        this.requestVideo({
          videoIdentity: this.currentItem.isAvailable
            ? this.currentItem.videoIdentity
            : this.currentItem.hightlightVideoIdentity
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  position: relative;
}
.try-see-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 718px;
  height: 80px;
  padding: 0 10px;
  opacity: 1;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  z-index: 1000;
  color: #ffffff;
  .font-wrap {
    display: flex;
    align-items: center;
  }
  .icon {
    width: 24px;
    height: 24px;
    background: url('./images/lock.png') no-repeat;
    background-size: contain;
    margin-right: 10px;
  }
  .unlock {
    width: 120px;
    height: 48px;
    opacity: 1;
    border-radius: 8px;
    background: rgba(40, 140, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.page {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-bottom: 190px;
}
.video {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
}

.statusBg {
  width: 100%;
  position: fixed;
  top: 0;
  height: 100px;
  z-index: 1;
}

.page-container {
  position: relative;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 160px;
}

.title {
  margin-top: 40px;
  margin-bottom: 30px;
  margin-left: 30px;
}

.marginL30 {
  margin-left: 30px;
}

.my-title {
  padding-bottom: 40px;
}

.jrgxTitle {
  margin-top: 40px;
}

.videoToday {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 26px 30px 39px;
  line-height: 106px;
  height: 106px;
  padding-left: 49px;
  background: #f3f3f3;
  position: relative;
  align-items: center;
}

.videoToday img {
  height: 52px;
  width: 52px;
  margin-right: 39px;
}

.sep20 {
  height: 20px;
  width: 100%;
}

.comment-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.cover {
  top: 0;
  position: fixed;
  z-index: 999;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.btnPlay {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50px, -50px);
}

.imgDefault {
  display: inline-block;
  background-color: #fff;
  background-image: url('../../static/img_load_default_l.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: 50%;
}

.onlineservice {
  position: fixed;
  right: 30px;
  width: 100px;
  height: 100px;
}
.my-swiper {
  z-index: 0;
}
</style>
